import { changeActivityColors as changeActivityColorsDiagram, getActivityColors as getActivityColorsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type ActivityColorsProps = {
    fill_color1?: string;
    text_color1? :string;
    select_color1? :string;
    fill_color2?: string;
    text_color2? :string;
    select_color2? :string;
    fill_color3?: string;
    text_color3? :string;
    select_color3? :string;
}

export const changeActivityColors = ({
    fill_color1,
    text_color1,
    select_color1,
    fill_color2,
    text_color2,
    select_color2,
    fill_color3,
    text_color3,
    select_color3,
}: ActivityColorsProps) => changeActivityColorsDiagram({
    fill_color1,
    text_color1,
    select_color1,
    fill_color2,
    text_color2,
    select_color2,
    fill_color3,
    text_color3,
    select_color3,
});

export const getActivityColors = (): ActivityColorsProps => getActivityColorsDiagram();
